var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeleteImgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 32.375C16.6779 32.375 14.8737 32.0161 13.1903 31.3188C11.5069 30.6215 9.97731 29.5995 8.68889 28.3111C7.40048 27.0227 6.37845 25.4931 5.68117 23.8097C4.98389 22.1263 4.625 20.3221 4.625 18.5C4.625 16.6779 4.98389 14.8737 5.68117 13.1903C6.37846 11.5069 7.40048 9.9773 8.68889 8.68889C9.97731 7.40048 11.5069 6.37845 13.1903 5.68117C14.8737 4.98389 16.6779 4.625 18.5 4.625C20.3221 4.625 22.1263 4.98389 23.8097 5.68117C25.4931 6.37846 27.0227 7.40048 28.3111 8.6889C29.5995 9.97731 30.6215 11.5069 31.3188 13.1903C32.0161 14.8737 32.375 16.6779 32.375 18.5C32.375 20.3221 32.0161 22.1263 31.3188 23.8097C30.6215 25.4931 29.5995 27.0227 28.3111 28.3111C27.0227 29.5995 25.4931 30.6215 23.8097 31.3188C22.1263 32.0161 20.3221 32.375 18.5 32.375L18.5 32.375Z",
    stroke: "#E8A941",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 13.875L23.125 23.125",
    stroke: "#E8A941",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.125 13.875L13.875 23.125",
    stroke: "#E8A941",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteImgCross);
export default __webpack_public_path__ + "static/media/icon-delete-img-cross.d7b49dea66717a8e1537ae21b4a8a7ba.svg";
export { ForwardRef as ReactComponent };